var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.016 4.616h4.968v4.968h-1.968v-3h-3zm3 12v-3h1.968v4.968h-4.968v-1.968zm-12-7.032V4.616h4.968v1.968h-3v3zm1.968 4.032v3h3v1.968H5.016v-4.968z"
})));
export default SvgShowMore;